export default __webpack_public_path__ + "4f30a4b3b730a8789230bac84966f9d0.svg";